import React from 'react';
import { usePageMeta } from '../hooks/usePageMeta';
import PremiumThankYou from '../components/PremiumThankYou';

const SubmittedApplicationPage = () => {
  usePageMeta({
    title: 'Application Submitted | BM-Assist.co',
    description: 'Your employment application has been received and is under review.',
    ogTitle: 'Application Submitted | BM-Assist.co',
    ogDescription: 'Thank you for applying to BM-Assist.'
  });

  const bulletPoints = [
    "Your application is now with our hiring team",
    "We'll review your experience and qualifications",
    "If you're a match, expect to hear from us within 48 hours"
  ];

  return (
    <PremiumThankYou
      title="Application Received!"
      subtitle="Thanks for your interest in joining the BM team."
      bulletPoints={bulletPoints}
      primaryButtonText="Back to Home"
      primaryButtonLink="/"
      secondaryButtonText="View Open Roles"
      secondaryButtonLink="/applications"
    />
  );
};

export default SubmittedApplicationPage;
